import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperatoriProiecteComponent } from './operatori-proiecte.component';
import { EditOperatoriProiecteComponent } from './edit-operatori-proiecte/edit-operatori-proiecte.component';
import { UpdateFunctieOperatoriProiecteComponent } from './update-functie-operatori-proiecte/update-functie-operatori-proiecte.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        OperatoriProiecteComponent,
        EditOperatoriProiecteComponent,
        UpdateFunctieOperatoriProiecteComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [
        OperatoriProiecteComponent
    ]
})
export class OperatoriProiecteModule { }
